<template>
  <div class="w-full">
    <md-field class="mb-0">
      <div class="isis-time-input w-full">
        <input
          :disabled="disabled"
          type="time"
          :value="value"
          @input="$emit('input', $event.target.value)"
          class="w-full h-full bg-transparent"
        />
        <div class="visual-value w-full h-full flex items-center">
          <p class="text-time flex-1" :class="{ hasValue }">{{ textTime }}</p>
          <md-icon class="clock-icon w-min ml-2">schedule</md-icon>
        </div>
      </div>
    </md-field>
    <slot></slot>
  </div>
</template>

<script>
import i18n from "../../lang/i18n";

export default {
  name: "isis-time-picker",
  props: {
    value: String,
    title: {
      type: String,
      default: i18n.t("common.choose_time")
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    textTime() {
      if (!this.value) {
        return this.$t(this.title);
      }

      const [hour, minute] = this.value.split(":");

      const isAfternoon = +hour >= 12;

      if (isAfternoon) {
        const standardHour = +hour === 12 ? hour : +hour - 12;

        return `${standardHour}:${minute} PM`;
      }

      return `${this.value} AM`;
    },
    hasValue() {
      return !!this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.isis-time-input {
  position: relative;
  cursor: pointer;
  min-width: 123px;
  padding: 6px 0;

  input[type="time"] {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 0;
    z-index: 1;

    cursor: pointer;

    &::-webkit-datetime-edit {
      display: none;
    }

    &::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: auto;
      height: auto;
      color: transparent;
      background: transparent;
      cursor: pointer;
    }
  }

  .text-time {
    font-size: 14px;
    font-weight: 400;
    color: #aaaaaa !important;
    line-height: 1.4;

    &.hasValue {
      color: #3c4858;
    }
  }

  .clock-icon {
    display: inline-block;
  }
}
</style>
